export const GET_ALL_JOURNEY = "GET_ALL_JOURNEY"
export const ADD_NEW_JOURNEY= "ADD_NEW_JOURNEY"
export const  DELETE_JOURNEY = "DELETE_JOURNEY"